export enum SIGNATURE_TYPE {
  DIIA = 0,
  CIPHER,
  IIT,
}
